module.exports = __webpack_public_path__ + "static/media/IappsBadgeGray.7dd71df1.png";